var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#311879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.194 4.774c-.647.54-1.766 1.762-1.766 3.137c0 1.71 2.049 2.872 3.116 3.493l.343.206c.891.549 2.97 1.92 2.97 4.114c0 2.083-1.8 3.459-2.752 3.965a.235.235 0 0 1-.265-.039a.215.215 0 0 1 .008-.317c.686-.6 1.723-1.894 1.723-3.193c0-1.787-1.534-2.743-2.721-3.429l-.142-.085c-1.478-.853-3.565-2.057-3.565-4.445c0-1.83 1.74-3.291 2.742-3.857a.284.284 0 0 1 .369.077c.086.12.056.279-.06.373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.571 7.843c0-1.397-1.106-2.593-1.74-3.112c-.094-.077-.12-.214-.043-.308a.24.24 0 0 1 .3-.064c.986.54 2.67 1.92 2.67 3.775c0 1.093-.471 1.98-1.105 2.688c-.206.12-.442.158-.686.02c-.467-.26-.24-.796-.013-1.212a3 3 0 0 0 .617-1.791zm-4.543 6.574h.026c-.38.488-.6 1.083-.626 1.702c0 1.303 1.085 2.622 1.745 3.223c.09.085.098.222.008.304a.24.24 0 0 1-.283.03l-.013-.004c-.685-.386-2.64-1.48-2.64-3.828c0-.964.412-1.774.952-2.43c.257-.223.557-.368.831-.214c.515.296.21.917 0 1.213z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgix);
export default __webpack_public_path__ + "static/media/agix.e384df1c842103ae5de5ff4687a6a411.svg";
export { ForwardRef as ReactComponent };